module.exports = __webpack_public_path__ + "src/img/artist/artist08.jpg?e5bae9edfbf8aa34e8a4bde3524f7d54";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist08.jpg
// module id = 115
// module chunks = 0